<template>
    <div>
        <rkm-form
            v-if="form && model"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        ref="periodo"
                        range
                        :range-inline="false"
                        start-label="Data inicial"
                        end-label="Data final"
                        v-model="model.periodo"
                        :minDate="model.minDate"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                        right
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-checkbox-group
                        label="Dias da semana"
                        v-model="model.diasSemana"
                        :options="form.diasSemana"
                        text-field="descricao"
                        value-field="id"
                        buttons
                        button-color="outline-primary"
                        :validations="validations.diasSemana"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :searchFields="localForm.autocompleteFields.motivo"
                        :repository="repositories.motivo"
                        label="Motivo da viagem"
                        text-field="descricao"
                        v-model="model.motivo"
                        uppercase
                        :validations="validations.motivo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        label="Horário da consulta/procedimento"
                        v-model="model.horario"
                        :validations="validations.horario"
                        right
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.municipios"
                        label="Município"
                        text-field="nome"
                        value-field="id"
                        v-model="model.municipio"
                        show-default-option
                        :validations="validations.municipio"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="form.destinos"
                        label="Local"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.destinoId"
                        show-default-option
                        :disabled="form.destinos.length == 0"
                        :validations="validations.destino"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        label="Observação do transporte"
                        v-model="model.observacao"
                        :validations="validations.observacao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-area
                title="Dados do transporte"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.acompanhante"
                            label="Acompanhante(s)"
                            v-model="model.acompanhante"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.pontos"
                            label="Ponto de referência do(a) paciente"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.pontoId"
                            show-default-option
                            :validations="validations.ponto"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-time-picker
                            label="Horário saida"
                            v-model="model.horarioSaida"
                            :validations="validations.horarioSaida"
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            label="Tipo de passageiro"
                            :options="form.tiposPassageiro"
                            :validations="validations.tipoPassageiro"
                            v-model="model.tipoPassageiroId"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :options="form.veiculos"
                            label="Veículo"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.veiculoId"
                            show-default-option
                            :disabled="!model.periodo || !model.diasSemana || !model.horario || !model.tipoPassageiroId"
                            :validations="model.jornadaId ? validations.veiculo : {}"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-select
                            v-if="!isLoadingJornadas"
                            :options="form.jornadas"
                            label="Jornada"
                            text-field="descricao"
                            value-field="id"
                            v-model="model.jornadaId"
                            :multiple="jornadaMultipla"
                            show-default-option
                            :disabled="!model.veiculoId || isLoadingJornadas"
                            :validations="model.veiculoId ? validations.jornada : {}"
                            @change="updateJornada"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="model.acompanhante > 0 && form.dadosAcompanhante"
                title="Acompanhante 1"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.nome1"
                            :validations="validations.acompanhante"
                            uppercase
                        />

                        <rkm-form-input-autocomplete
                            v-else
                            label="Nome"
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            v-model="model.acompanhante1"
                            :validations="validations.acompanhante"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-mask="mask.cns"
                            :value="acompanhante1Cns"
                            :disabled="!form.campoLivre"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Telefone"
                            v-model="model.telefone1"
                            v-mask="mask.cellPhone"
                        />

                        <rkm-form-input
                            v-else
                            label="Telefone"
                            :value="acompanhante1Telefone"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.relacao1"
                            :validations="validations.relacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                v-if="model.acompanhante > 1 && form.dadosAcompanhante"
                title="Acompanhante 2"
                type="fieldset"
                no-margin-top
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Nome"
                            v-model="model.nome2"
                            :validations="validations.acompanhante"
                            uppercase
                        />

                        <rkm-form-input-autocomplete
                            v-else
                            label="Nome"
                            :repository="repositories.paciente"
                            :search-fields="fields.paciente"
                            :text-field="(item) => item.cidadao.nome"
                            v-model="model.acompanhante2"
                            :validations="validations.acompanhante"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            label="CNS"
                            v-mask="mask.cns"
                            :value="acompanhante2Cns"
                            :disabled="!form.campoLivre"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            v-if="form.campoLivre"
                            label="Telefone"
                            v-model="model.telefone2"
                            v-mask="mask.cellPhone"
                        />

                        <rkm-form-input
                            v-else
                            label="Telefone"
                            :value="acompanhante2Telefone"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Relação"
                            :options="form.relacoes"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            v-model="model.relacao2"
                            :validations="validations.relacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <ModalListaAgendamento ref="ModalListaAgendamento" />
    </div>
</template>

<script>
import ModalListaAgendamento from './components/agendamento/Modal'
import { repository, stringCase, printTransportePacientePreAgendamento, mask, data, unmask } from "@/mixins"
import status from "@/enums/transporte-paciente/agendar-transporte/status"
import format from '@/filters/formats'
import { mapActions } from "vuex"
import moment from "moment"

export default {
    components: { ModalListaAgendamento },
    created() {
        this.repositories = {
            preAgendamentoTransporte: this.getConectaSusRepository("transportePaciente.preAgendamentoTransporte"),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            agendar: this.getConectaSusRepository('transportePaciente.agendar'),
            motivo: this.getConectaSusRepository("transportePaciente.motivo"),
        }
    },
    computed: {
        acompanhante1Cns() {
            return this.model.acompanhante1?.cidadao ? format.formatCns(this.model.acompanhante1.cidadao.cns) : null
        },
        acompanhante1Telefone() {
            return this.model.acompanhante1?.cidadao?.telefonePrincipal ? format.formatPhoneOrCellPhone(this.model.acompanhante1.cidadao.telefonePrincipal.numero) : null
        },
        acompanhante2Cns() {
            return this.model.acompanhante2?.cidadao ? format.formatCns(this.model.acompanhante2.cidadao.cns) : null
        },
        acompanhante2Telefone() {
            return this.model.acompanhante2?.cidadao?.telefonePrincipal ? format.formatPhoneOrCellPhone(this.model.acompanhante2.cidadao.telefonePrincipal.numero) : null
        },
        fields() {
            return {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                diasSemana: {
                    required: true,
                },
                motivo: {
                    required: true,
                },
                horario: {
                    required: true,
                },
                ponto: {
                    required: true,
                },
                municipio: {
                    required: true,
                },
                destino: {
                    required: true,
                },
                tipoPassageiro: {
                    required: true,
                },
                observacao: {
                    max: 200,
                },
                acompanhante: {
                    required: true
                },
                relacao: {
                    required: true
                },
                veiculo: {
                    required: true
                },
                jornada: {
                    required: true
                },
                horarioSaida: {
                    max_hour: this.getFormatedDate(this.model.data, 'YYYY-MM-DD') === this.getFormatedDate(this.model.dataSaida, 'YYYY-MM-DD')
                        ? this.getMaxHour() : false,
                    required: this.model.jornadaId ? true : false
                }
            }
        }
    },
    data: () => ({
        enums: { status },
        localForm: {
            autocompleteFields: {
                motivo: [
                    {
                        key: "descricao",
                        searchable: true,
                    }
                ],
            }
        },
        isLoadingJornadas: false,
        jornadaMultipla: false
    }),
    watch: {
        'model.municipio': function(municipio) {
            if (municipio) {
                this.getDestinos()
            }
        },
        'model.periodo': {
            deep: true,
            handler: function() {
                this.$nextTick().then(() => this.handleDiasSemana())
                this.model.tipoPassageiroId = null
            }
        },
        'model.diasSemana': {
            handler: function() {
                this.model.tipoPassageiroId = null
            }
        },
        'model.horario': {
            handler: function() {
                this.model.tipoPassageiroId = null
            }
        },
        'model.acompanhante': function (acompanhante) {
            if (acompanhante < 2) {
                this.model.acompanhante2 = null
            }
            if (acompanhante < 1) {
                this.model.acompanhante1 = null
            }
        },
        'model.tipoPassageiroId': function(tipoPassageiroId) {
            if (tipoPassageiroId) {
                this.getVeiculos()
            } else {
                this.jornadaMultipla = false
            }
            this.model.veiculoId = null
        },
        'model.veiculoId': function(veiculoId) {
            if (veiculoId) {
                this.getJornadas()
            }
            this.model.jornadaId = null
        },
        'model.horarioSaida': {
            handler: function () {
                const tipoAtual = this.model.tipoPassageiroId
                this.model.tipoPassageiroId = tipoAtual
            }
        },
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        getMaxHour() {
            return this.model.horario ? moment(this.model.horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm') : false
        },
        handleDiasSemana() {
            this.disabledSemanas()

            const periodo = this.model.periodo

            if(periodo.start || periodo.end){
                let indices = []
                if(periodo.start){
                    let dataStart = moment(periodo.start, this.dateFormatUs).toDate()
                    const index = this.form.diasSemana.findIndex(dia => dia.id == dataStart.getDay() + 1)
                    indices.push(index)
                }
                if(periodo.end){
                    let dataEnd = moment(periodo.end, this.dateFormatUs).toDate()
                    const index = this.form.diasSemana.findIndex(dia => dia.id == dataEnd.getDay() + 1)
                    indices.push(index)
                }
                if(periodo.start && periodo.end){
                    indices = []
                    let dataStart = moment(periodo.start, this.dateFormatUs)
                    let dataEnd = moment(periodo.end, this.dateFormatUs)
                    let indice = 0
                    while(dataStart.isSameOrBefore(dataEnd) && indice < 7){
                        const index = this.form.diasSemana.findIndex(dia => dia.id == dataStart.toDate().getDay() + 1)
                        indices.push(index)
                        dataStart.add(1,'d')
                        indice++
                    }

                    if(moment(periodo.start).isSame(periodo.end)) {
                        this.model.diasSemana = [(indices[0] + 1)]
                    }
                }
                indices.forEach(indice => {
                    this.form.diasSemana[indice].disabled = false
                })

            }
        },
        disabledSemanas(){
            this.form.diasSemana.forEach(dia => dia.disabled = true)
        },
        getDestinos() {
            this.setLoading()
            this.repositories.agendar.getDestinos({
                municipio_id: this.model.municipio
            })
                .then(({ data }) => {
                    this.form.destinos = data
                    if(data.length == 1) {
                        this.model.destinoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getVeiculos() {

            this.setLoading()

            const dataInicial = this.model.periodo.start
            const dataFinal = this.model.periodo.end

            this.repositories.agendar.getVeiculos({
                'agendar_transporte_jornada': true,
                'data_inicial': this.getFormatedDate(dataInicial, 'YYYY-MM-DD'),
                'data_final': this.getFormatedDate(dataFinal, 'YYYY-MM-DD'),
                'horario_consulta': this.model.horario,
                'dia_semana': this.model.diasSemana
            })
                .then(({ data }) => {
                    this.form.veiculos = data
                    if(data.length == 1) {
                        this.model.veiculoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getJornadas() {

            this.isLoadingJornadas = true
            this.jornadaMultipla = false
            this.setLoading()

            const dataInicial = this.model.periodo.start
            const dataFinal = this.model.periodo.end

            this.repositories.agendar.getJornadas({
                'veiculo_id': this.model.veiculoId,
                'data_inicial': this.getFormatedDate(dataInicial, 'YYYY-MM-DD'),
                'data_final': this.getFormatedDate(dataFinal, 'YYYY-MM-DD'),
                'dia_semana': this.model.diasSemana
            })
                .then(({ data }) => {
                    this.form.jornadas = data
                    if(data.length === 1) {
                        this.model.jornadaId = data[0].id
                        if (!this.model.horarioSaida) {
                            this.model.horarioSaida = data[0].dataInicial.split(" ")[1].substring(0, 5)
                        }
                    } else if (data.length > 1) {
                        this.jornadaMultipla = true
                        this.model.jornadaId = []
                        if (!this.model.horarioSaida) {
                            this.model.horarioSaida = data[0].dataInicial.split(" ")[1].substring(0, 5)
                        }
                    } else {
                        this.model.jornadaId = null
                    }
                    this.updateJornada(this.model.jornadaId)
                })
                .catch(this.handleError)
                .finally(() => {
                    this.isLoadingJornadas = false
                    this.unsetLoading()
                })
        },
        updateJornada(idsSelecionados) {
            if (!idsSelecionados && this.model.jornadasSelecionadas?.length > 0) {
                this.model.jornadasSelecionadas = this.model.jornadasSelecionadas.map(jornada => ({
                    id: jornada.id,
                    data: moment(jornada.data).format('YYYY-MM-DD')
                }))
                return
            }
            if (Array.isArray(idsSelecionados)) {
                this.model.jornadasSelecionadas = idsSelecionados.map(id => {
                    const jornadaSelecionada = this.form.jornadas.find(j => j.id === id);
                    return jornadaSelecionada
                        ? { id: jornadaSelecionada.id, data: moment(jornadaSelecionada.dataInicial).format('YYYY-MM-DD') }
                        : null
                }).filter(jornada => jornada !== null)
            } else {
                const jornadaSelecionada = this.form.jornadas.find(j => j.id === idsSelecionados)
                this.model.jornadasSelecionadas = jornadaSelecionada
                    ? [{ id: jornadaSelecionada.id, data: moment(jornadaSelecionada.dataInicial).format('YYYY-MM-DD') }]
                    : []
            }
        },
        adicionarAgendamentos() {
            this.$refs.Form.validate().then(valid => {
                if (valid) {
                    const _dataInicialFormatada = moment(this.model.periodo.start).format(this.dateFormatUs)
                    const _dataFinalFormatada = moment(this.model.periodo.end).format(this.dateFormatUs)
                    this.validaAgendamentos(_dataInicialFormatada,_dataFinalFormatada)
                }
            })
        },
        validaAgendamentos(dataInicialFormatada, dataFinalFormatada) {
            let dataInicialAgendamento = moment(dataInicialFormatada)
            let dataFinalAgendamento = moment(dataFinalFormatada)
            let agendamentos = []
            let msg = ''

            const diferenca = dataFinalAgendamento.diff(dataInicialAgendamento, "days")

            if(diferenca < 0) {
                this.showAlert('O periodo selecionado é inválido', 'Atenção')
                return false
            }

            if (diferenca > 30) {

                msg = 'Período do pré-agendamento excede 30 dias'
            }

            for (let dia = 0; dia <= diferenca; dia++) {
                dataInicialAgendamento = moment(dataInicialFormatada).add(dia, "d")
                dataFinalAgendamento = moment(dataFinalFormatada).add(dia, "d")
                if(this.model.diasSemana.includes(dataInicialAgendamento.day() + 1)) {
                    agendamentos.push(
                        {
                            motivoId: this.model.motivo.id,
                            horario: this.model.horario,
                            data: dataInicialAgendamento.format('YYYY-MM-DD'),
                        })
                }
            }

            const sameDate = agendamentos.some(agendar => {
                return this.agendamentos.some(agendamento => {
                    return moment(agendamento.preAgendamentoData).isSame(agendar.data)
                }) || this.agendados.some(agendado => {
                    return moment(agendado.data).isSame(agendar.data)
                })
            })

            const showMessage = () => {

                if(msg) {
                    this.showConfirmation(msg + '. Deseja continuar?', async () => {

                        this.$nextTick().then(() => this.montaAgendamentos(dataInicialFormatada, dataFinalFormatada))
                    })
                }
            }

            if(!sameDate) {
                if (msg == '') {
                    this.montaAgendamentos(dataInicialFormatada, dataFinalFormatada)
                }
            } else {

                let agendamentosEPreAgendamentosSameDate = []

                agendamentos.forEach(agendar => {

                    agendamentosEPreAgendamentosSameDate = agendamentosEPreAgendamentosSameDate.concat(this.agendamentos
                        .filter(agendamento => {
                            return moment(agendamento.preAgendamentoData).isSame(agendar.data)
                        })
                        .map(agendamento => ({
                            data: agendamento.preAgendamentoData,
                            motivoDescricao: agendamento.transportePacienteMotivo,
                            municipio: agendamento.municipio,
                            destino: agendamento.transportePacienteDestino,
                            horario: agendamento.preAgendamentoHorario.substring(0, 5),
                            veiculoId: agendamento.veiculoId,
                            veiculoDescricao: agendamento.veiculoDescricao,
                            jornadaDescricao: agendamento.jornadaDescricao,
                            observacao: agendamento.observacao,
                        }))
                    )

                    agendamentosEPreAgendamentosSameDate = agendamentosEPreAgendamentosSameDate.concat(this.agendados
                        .filter(agendado => {
                            return moment(agendado.data).isSame(agendar.data)
                        })
                        .map(agendado => ({
                            data: agendado.data,
                            motivoDescricao: agendado.motivoDescricao,
                            municipio: agendado.municipio,
                            destino: agendado.destino,
                            horario: agendado.horario,
                            veiculoId: agendado.veiculoId,
                            veiculoDescricao: agendado.veiculoDescricao,
                            jornadaDescricao: agendado.jornadaDescricao,
                            observacao: agendado.observacao,
                        }))
                    )
                })

                const montaAgendamentos = () => {
                    if(agendamentos.every(agendamento => this.verificaTurno(agendamento, this.model.horaConsulta))){

                        if (msg == '') {
                            this.montaAgendamentos(dataInicialFormatada, dataFinalFormatada)
                        }
                    } else {
                        if (msg) {
                            msg = msg + ' e o paciente possui agendamento para o mesmo dia/turno selecionado'
                        } else {
                            msg = 'O paciente possui agendamento para o mesmo dia/turno selecionado'
                        }
                    }

                    showMessage()
                }

                this.$refs.ModalListaAgendamento.open(agendamentosEPreAgendamentosSameDate, montaAgendamentos)

                return false
            }

            showMessage()
        },
        verificaMotivo(data, motivo) {
            return Array.from(this.agendamentos).filter(agendamento => {
                return agendamento.preAgendamentoData == data.format('YYYY-MM-DD')
            }).some(agendamento => {
                return agendamento.motivoId == motivo
            })
        },
        verificaTurno(agendamento, horaConsulta){
            let sameDays = this.agendamentos.filter(agendado => {
                return moment(agendado.data).isSame(agendamento.data)
            })
            const hora = moment(horaConsulta, 'HH:mm')
            const turnos = sameDays.map(day => {
                const turno = moment(day.hora, 'HH:mm')
                if(turno.isBefore(moment('11:59', 'HH:mm')) && turno.isAfter(moment('00:00', 'HH:mm'))){
                    return 'Manhã'
                }
                if(turno.isBefore(moment('18:00', 'HH:mm')) && turno.isAfter(moment('12:00', 'HH:mm'))){
                    return 'Tarde'
                }
                if(turno.isBefore(moment('23:59', 'HH:mm')) && turno.isAfter('18:01', 'HH:mm')){
                    return 'Noite'
                }
            })
            if(hora.isBefore(moment('11:59', 'HH:mm')) && hora.isAfter(moment('00:00', 'HH:mm'))){
                return !turnos.some(turno => turno == 'Manhã')
            }
            if(hora.isBefore(moment('18:00', 'HH:mm')) && hora.isAfter(moment('12:00', 'HH:mm'))){
                return !turnos.some(turno => turno == 'Tarde')
            }
            if(hora.isBefore(moment('23:59', 'HH:mm')) && hora.isAfter('18:01', 'HH:mm')){
                return !turnos.some(turno => turno == 'Noite')
            }
        },
        montaAgendamentos(dataInicialFormatada, dataFinalFormatada) {
            const dataInicialAgendamento = moment(dataInicialFormatada)
            const dataFinalAgendamento = moment(dataFinalFormatada)
            const agendamentos = []

            for (let dia = 0; dia <= dataFinalAgendamento.diff(dataInicialAgendamento, 'days'); dia++) {
                const currentDate = moment(dataInicialAgendamento).add(dia, 'd')
                if (this.model.diasSemana.includes(currentDate.day() + 1)) {
                    agendamentos.push({
                        pacienteId: parseInt(this.model.pacienteId),
                        municipioId: this.model.municipio,
                        municipio: this.model.municipio.nome,
                        destinoId: this.model.destinoId,
                        transportePacienteDestino: this.form.destinos.find(destino => destino.id == this.model.destinoId).descricao,
                        motivoId: this.model.motivo.id,
                        transportePacienteMotivo: this.model.motivo.descricao,
                        preAgendamentoData: currentDate.format('YYYY-MM-DD'),
                        preAgendamentoHorario: this.model.horario,
                        horario: this.model.horario,
                        data: currentDate.format('YYYY-MM-DD'),
                        observacao: this.model.observacao,
                        acompanhante: this.model.acompanhante,
                        acompanhante1Id: this.model.acompanhante1?.id ?? null,
                        acompanhante1Relacao: this.model.relacao1 ?? null,
                        nome1: this.model.nome1 ?? null,
                        telefone1: this.model.telefone1 ? this.unMaskPhone(this.model.telefone1) : null,
                        acompanhante2Id: this.model.acompanhante2?.id ?? null,
                        acompanhante2Relacao: this.model.relacao2 ?? null,
                        nome2: this.model.nome2 ?? null,
                        telefone2: this.model.telefone2 ? this.unMaskPhone(this.model.telefone2) : null,
                        pontoId: this.model.pontoId,
                        horarioSaida: this.model.horarioSaida,
                        veiculoId: this.model.veiculoId,
                        jornadaId: this.model.jornadaId,
                        tipoPassageiroId: this.model.tipoPassageiroId,
                    })
                }
            }

            if(this.model.veiculoId && this.model.jornadaId) {

                this.jornadaValida(agendamentos)
            } else {

                this.save(agendamentos)
            }

        },
        jornadaValida(agendamentos) {
            const datasSemJornada = []
            const agendamentosValidos = agendamentos.filter(agendamento => {
                const dataAgendamento = agendamento.data
                    ? moment(agendamento.data).format('YYYY-MM-DD')
                    : agendamento.preAgendamentoData

                const jornadaIdValida = this.model.jornadasSelecionadas?.find(jornada => jornada.data === dataAgendamento)

                if (!jornadaIdValida) {
                    datasSemJornada.push(dataAgendamento)
                    return false
                }

                return true
            })

            if (datasSemJornada.length > 0 && this.model.horarioSaida && this.model.veiculoId) {
                const datasFormatadas = datasSemJornada.map(data => moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY'))

                this.showConfirmation(
                    `O(s) pré-agendamento(s) da(s) data(s) ${datasFormatadas.join(', ')}, não possue(m) jornada. Ele(s) não será(ão) salvo(s). Deseja continuar?`,
                    async () => {
                        this.$nextTick().then(() => this.capacidadeVeiculo(agendamentosValidos))
                    }
                )
            } else {
                this.capacidadeVeiculo(agendamentosValidos)
            }
        },
        capacidadeVeiculo(agendamentos) {

            const agendamentosPorData = {};
            const veiculoLotado = [];

            agendamentos.forEach(agendamento => {
                const veiculo = this.form.veiculos.find(v => v.id == agendamento.veiculoId);
                const dataAgendamento = agendamento.data
                    ? moment(agendamento.data).format('YYYY-MM-DD')
                    : agendamento.preAgendamentoData;

                if (!agendamentosPorData[dataAgendamento]) {
                    agendamentosPorData[dataAgendamento] = {
                        totalAgendados: 0,
                        agendamentos: []
                    };
                }

                const acompanhante = agendamento.acompanhante || 0;
                agendamentosPorData[dataAgendamento].totalAgendados += acompanhante + 1;
                agendamentosPorData[dataAgendamento].agendamentos.push({ agendamento, veiculo });
            });

            for (const data in agendamentosPorData) {
                const { totalAgendados, agendamentos } = agendamentosPorData[data];

                agendamentos.forEach(({ veiculo }) => {
                    if (veiculo) {

                        const totalAgendadosVeiculo = veiculo.agendados
                            ? veiculo.agendados.filter(agendamento => agendamento.dataSaida === data)
                                .reduce((total, agendamento) => {
                                    return total + parseInt(agendamento.quantidade || 0);
                                }, 0)
                            : (veiculo.totalAgendados ? veiculo.totalAgendados : 0);
                        const capacidade = veiculo.capacidade || 0;
                        const totalAtual = totalAgendados + totalAgendadosVeiculo;

                        const excedido = totalAtual > parseInt(capacidade);

                        if (excedido) {
                            veiculoLotado.push(data);
                        }
                    }
                });

                if (veiculoLotado.length > 0) {
                    const datasFormatadas = veiculoLotado.map(data => moment(data, 'YYYY-MM-DD').format('DD-MM-YYYY'));
                    this.showAlert(`Na viagem do(s) dia(s) ${datasFormatadas.join(', ')}, a capacidade do veículo já foi atingida, escolha outro veículo, ou retire essa(s) data(s) do agendamento`, 'Atenção');
                    return;
                }
            }

            this.save(agendamentos);
        },
        save(agendamentos) {

            this.showConfirmation(
                'Deseja já agendar o transporte do paciente? Caso não queira, as informações serão salvas somente como pré agendamento?',
                async () => this.handleSave(agendamentos, true),
                async () => this.handleSave(agendamentos)
            )
        },
        handleSave(agendamentos, agendar = false) {
            this.setLoading()
                this.repositories.preAgendamentoTransporte
                    .store(this.prepareData(agendamentos, agendar))
                    .then(({ data }) => {
                        this.$emit('add', data)
                        this.handlePrint()
                        this.showSaveNotification()
                        this.resetForm()
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.unsetLoading()
                    })
        },
        prepareData(agendamentos, agendar = false) {

            return this.camelObjectKeysToSnakeRecursive({
                agendamentos: agendamentos.map(
                    agendamento => {
                        const dataSaida = agendamento.dataSaida ? moment(agendamento.dataSaida).format('YYYY-MM-DD') : agendamento.preAgendamentoData
                        const jornadaIdValida = this.model.jornadasSelecionadas ? this.model.jornadasSelecionadas.find(jornada => jornada.data === dataSaida) : undefined
                        return {
                            pacienteId: agendamento.pacienteId,
                            motivoId: agendamento.motivoId,
                            horario: agendamento.preAgendamentoHorario,
                            data: agendamento.preAgendamentoData,
                            municipioId: agendamento.municipioId,
                            destinoId: agendamento.destinoId,
                            acompanhante: agendamento.acompanhante,
                            acompanhante1: agendamento.acompanhante >= 1 ? {
                                usuario_id: agendamento.acompanhante1Id,
                            } : undefined,
                            acompanhante2: agendamento.acompanhante >= 2 ? {
                                usuario_id: agendamento.acompanhante2Id,
                            } : undefined,
                            acompanhante_1Id: agendamento.acompanhante1Id,
                            acompanhante_1Relacao: agendamento.acompanhante1Relacao,
                            nome1: agendamento.nome1,
                            relacao1: agendamento.acompanhante1Relacao,
                            telefone1:agendamento.telefone1,
                            acompanhante_2Id: agendamento.acompanhante2Id,
                            acompanhante_2Relacao: agendamento.acompanhante2Relacao,
                            nome2: agendamento.nome2,
                            relacao2: agendamento.acompanhante2Relacao,
                            telefone2:agendamento.telefone2,
                            pontoId: agendamento.pontoId,
                            observacao: agendamento.observacao,
                            dataSaida: dataSaida,
                            horarioSaida: agendamento.horarioSaida ?? undefined,
                            veiculoId: jornadaIdValida || (agendamento.jornadaId && typeof agendamento.jornadaId !== 'object') ? agendamento.veiculoId : null,
                            jornadaId: jornadaIdValida ? jornadaIdValida.id :
                                (agendamento.jornadaId && typeof agendamento.jornadaId !== 'object' ? agendamento.jornadaId : null),
                            statusId: this.enums.status.AGENDADO,
                            tipoPassageiroId: agendamento.tipoPassageiroId,
                            agendar
                        }
                    }
                )
            })
        },
        resetForm() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.diasSemana = []
            this.model.motivo = null
            this.model.horario = null
            this.model.pontoId = null
            this.model.municipio = null
            this.model.destinoId = null
            this.model.tipoPassageiroId = null
            this.model.observacao = null
            this.model.acompanhante = 0
            this.model.veiculoId = null
            this.model.jornadaId = null
            this.model.jornadasSelecionadas = []
            this.model.horarioSaida = null
            this.$refs.Form.resetValidator()
        },
        handlePrint() {
            const destino = this.form.destinos.find(destino => destino.id == this.model.destinoId)
            const ponto = this.form.pontos.find(ponto => ponto.id == this.model.pontoId)
            const agendamento = {
                pacienteNome: this.paciente.nome,
                pacienteNomeSocial: this.paciente.nomeSocial,
                pacienteTelefones: this.paciente.telefones,
                pacienteClassificacao: this.paciente.classificacao,
                unidadeReferencia: this.paciente.unidadeReferencia,
                prontuario: this.paciente.prontuario,
                dataNascimento: moment(this.paciente.dataNascimento).format('DD/MM/YYYY'),
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                unidade: this.form.unidade,
                unidadeTelefone: this.form.unidadeTelefone,
                destino: destino ? destino.descricao : '',
                motivo: this.model.motivo ? this.model.motivo.descricao : '',
                ponto: ponto ? ponto.descricao : '',
                acompanhante: this.model.acompanhante == 0 ? 'Nenhum' : this.model.acompanhante ?? '',
                comprovanteAcompanhante: this.form.comprovanteAcompanhante,
                acompanhante1Nome: this.model.nome1 ?? this.model.acompanhante1?.cidadao?.nome,
                acompanhante1Cns: this.acompanhante1Cns,
                acompanhante1Telefone: this.acompanhante1Telefone,
                acompanhante1Relacao: this.form.relacoes.find(relacao => relacao.id == this.model.relacao1)?.descricao,
                acompanhante2Nome: this.model.nome2 ?? this.model.acompanhante2?.cidadao?.nome,
                acompanhante2Cns: this.acompanhante2Cns,
                acompanhante2Telefone: this.acompanhante2Telefone,
                acompanhante2Relacao: this.form.relacoes.find(relacao => relacao.id == this.model.relacao2)?.descricao,
                horario: this.model.horario ?? '',
                observacao: this.model.observacao ?? '',
                dataInicial: this.model.periodo.start ? moment(this.model.periodo.start).format('DD/MM/YYYY') : '',
                dataFinal: this.model.periodo.end ? moment(this.model.periodo.end).format('DD/MM/YYYY') : '',
                mensagemProtocolo: this.form.mensagemProtocolo,
            }
            this.print().agendar(agendamento)
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        agendamentos: { type: Array, required: true },
        agendados: { type: Array, required: true },
        paciente: { type: Object, required: true },
    },
    mixins: [ repository, stringCase, printTransportePacientePreAgendamento, mask, data, unmask ],
}
</script>